import { objectSelector } from 'theme/utils';

const $P = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/signin`);

class SignInSmsRejected {
  constructor(data) {
    const { phone, smsCode } = data;
    this.phone = phone;
    this.smsCode = smsCode;
  }
}

export const signInSmsRejectedMapper = (error) => {
  return new SignInSmsRejected({
    phone: objectSelector(error, $P.ERROR_MESSAGES.PHONE),
    smsCode: objectSelector(error, $P.ERROR_MESSAGES.SMS_CODE),
  });
};



// WEBPACK FOOTER //
// ./src/models/signInSmsRejected.js